export default function nop(..._args: any[]): void {
  // Nothing to see here
}
